import { render, staticRenderFns } from "./StatDoctor.vue?vue&type=template&id=86ce7960"
import script from "./StatDoctor.vue?vue&type=script&lang=js"
export * from "./StatDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports